import { render, staticRenderFns } from "./reportType.vue?vue&type=template&id=6a14121c&scoped=true&"
import script from "./reportType.vue?vue&type=script&lang=js&"
export * from "./reportType.vue?vue&type=script&lang=js&"
import style0 from "./reportType.vue?vue&type=style&index=0&id=6a14121c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a14121c",
  null
  
)

export default component.exports